import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useDispatch } from 'react-redux';
import * as authService from '../../services/auth';
import { Roles } from '../../models/roles';
import ReceiverDashboard from '../../containers/ReceiverDashboard';
import { setDefaultDashboard } from '../../actions/uiPersisted';
import routes from '../../routes';
import LandingDashboard from '../rescuerDashboard/rescuerDashboardMobile/LandingDashboard';

const NotImplementedDashboard = params => {
  const { renderParams } = params;
  return (
    <>
      <h3>{`${renderParams.role} Dashboard`}</h3>

      <p>This is a placeholder for now. In the future, you'll see content useful for Receiver staff.</p>
    </>
  );
};

const ReceiverDashboardDesktop = () => {
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.only('xs'));
  const dispatch = useDispatch();
  const params = useParams();

  useEffect(() => {
    // set as default dashboard
    dispatch(setDefaultDashboard({ route: routes.dashboardReceiver, params }));
  }, []);

  if (isMobileView) {
    return <LandingDashboard />;
  }

  const currentlyLoggedInUser = authService.getCurrentlyLoggedInOrImpersonatingUser();
  const userRoles = authService.getUserRolesInCurrentlySelectedSite(currentlyLoggedInUser);
  let rolesWithAccess;

  rolesWithAccess = userRoles.filter(
    role => role.role_name === Roles.ReceiverLocationAdmin || role.role_name === Roles.ReceiverLocationStaff
  );

  if (rolesWithAccess.length > 0) {
    return <ReceiverDashboard renderParams={{ id: rolesWithAccess[0].receiver_id }} />;
  }

  rolesWithAccess = userRoles.filter(
    role => role.role_name === Roles.ReceiverAdmin || role.role_name === Roles.ReceiverStaff
  );

  if (rolesWithAccess.length > 0) {
    return <NotImplementedDashboard renderParams={{ role: rolesWithAccess[0].role_name }} />;
  }

  // fallback when user does not have any Receiver role.
  return (
    <Box my={2}>
      <Card>
        <CardContent>
          <Typography color="error">No data to present. Probably you are not a DonorLocationAdmin?</Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ReceiverDashboardDesktop;
